import { useEffect } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { functionWithCondition } from '@atlaskit/platform-feature-flags-react';

const useStaleTransitionGuardEnabled = (
	isStaleTransition: boolean,
	onInvalidAction?: () => void,
): void => {
	useEffect(() => {
		if (isStaleTransition) {
			onInvalidAction?.();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isStaleTransition]);
};

export const useStaleTransitionGuard: (
	isStaleTransition: boolean,
	onInvalidAction?: () => void,
) => void = functionWithCondition(
	() => fg('jira-status-action-transition-validation'),
	useStaleTransitionGuardEnabled,
	() => {},
);
